import * as tslib_1 from "tslib";
import { createStore } from 'satcheljs';
import { ObservableMap } from 'owa-mobx4-adapter';
export var defaultSearchStore = {
    currentSearchQueryId: null,
    isFocusInSearchInput: false,
    isSearchHistoryDirty: false,
    isSavedSearchesDirty: false,
    nextSearchQueryId: null,
    previousNode: null,
    suggestionPillIds: [],
    suggestionPills: new ObservableMap(),
    selectedPillIndex: -1,
    suggestionSegments: [],
    searchNumber: 0,
    searchSessionGuid: null,
    searchText: '',
    searchTextForSuggestion: undefined,
    selectedSuggestionIndex: -1,
    showFiltersMenu: false,
    staticSearchScope: null,
    staticSearchScopeList: null,
    suggestions: new ObservableMap({}),
    currentSuggestions: null,
    toDate: null,
    fromDate: null,
    includeAttachments: false,
    latestQfRequestId: null,
    latestTraceId: null,
    displayedQfRequestTime: null,
    initialSearchScope: null,
    ghostText: '',
    alteredQuery: '',
    suggestedSearchTerm: '',
    suggestedSearchTermReferenceId: '',
    flaggedTokens: [],
    recourseQuery: '',
};
var initialDefaultSearchStore = tslib_1.__assign({}, defaultSearchStore);
export var getStore = createStore('searchStore', initialDefaultSearchStore);
var store = getStore();
export default store;
//# sourceMappingURL=store.js.map